import { Select } from "antd";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import SpinLoader from "../loader/SpinLoader";
import { useNavigate } from "react-router-dom";
import { Edit } from "feather-icons-react/build/IconComponents";
import { API_BASE_URL, GET_USER_STORES } from "../../Config";

const initialData = {
  success: true,
  model_used: "gpt-4.1",
  extracted_text: {
    Quotation: {
      MS: "PASHA BHAI BNI",
      Add: "MOTINAGAR",
      Phone: "9885095194",
      "Bill No": "1,542",
      Date: "09-Feb-26",
      Type: "CREDIT",
      Items: [
        {
          SNo: 1,
          Size: "48X24",
          Code: "PNT",
          "Item Desc": "MONTAGE GREY ENDLESS ",
          Location: "FLOOR",
          Qty: 63,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 2,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "EMIL WHITE",
          Location: "ATTACH BATH",
          Qty: 8,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 3,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "PULPIS GREY MATT(2X2)",
          Location: "",
          Qty: 2,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 4,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "OCEAN GRIS",
          Location: "ATTACH BATH 1",
          Qty: 8,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 5,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "MALAGA LIGHT GREY",
          Location: "",
          Qty: 2,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 6,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "ROWAN GRIS",
          Location: "COMM. BATH",
          Qty: 10,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 7,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "VERSAILLES CARRARA MARBLE",
          Location: "COMM. BATH 1",
          Qty: 11,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 8,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "MALAGA ASH",
          Location: "",
          Qty: 2,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 9,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "MARMI ORO FIRENZE",
          Location: "WASH AREA",
          Qty: 8,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
        {
          SNo: 10,
          Size: "24X24",
          Code: "PCAN",
          "Item Desc": "OFICIANA BEIGE",
          Location: "",
          Qty: 4,
          Unit: "Sft",
          Rate: 85,
          Amt: 16320.0,
        },
      ],
      Total: "118 BOX",
      Note: "Goods once sold, will not be taken back.",
      "Authorised Signatory": "ASHISH",
    },
  },
  tokens: {
    input_tokens: 819,
    output_tokens: 767,
    total_tokens: 1586,
  },
};

function ImageUpload() {
  const [file, setFile] = useState(null);
  const [responseData, setResponseData] = useState(initialData);
  console.log(responseData, "ressssssssssssssssssssssss");
  const quotation = responseData?.extracted_text?.Quotation;
  console.log(quotation, "qqqqqqqqqqqqqqq");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [showCanvas, setShowCanvas] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      navigate("/");
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const handleEditClick = (item, index) => {
    setEditItem({ ...item }); // clone row
    setEditIndex(index);
    setShowCanvas(true);
  };

  const handleSubmitOfcanvas = () => {
    const updatedItems = [...quotation.Items];
    updatedItems[editIndex] = editItem;

    updateQuotationField("Items", updatedItems);

    setShowCanvas(false);

    Swal.fire({
      icon: "success",
      title: "Row updated successfully",
      showConfirmButton: false,
      timer: 1500,
      toast: true,
      position: "top-center",
    });
  };

  const updateQuotationField = (field, value) => {
    setResponseData((prev) => ({
      ...prev,
      extracted_text: {
        ...prev.extracted_text,
        Quotation: {
          ...prev.extracted_text.Quotation,
          [field]: value,
        },
      },
    }));
  };

  // const updateQuotationItem = (index, key, value) => {
  //     setResponseData((prev) => {
  //         const items = [...prev.extracted_text.Quotation.Items];
  //         items[index][key] = value;
  //         return {
  //             ...prev,
  //             extracted_text: {
  //                 ...prev.extracted_text,
  //                 Quotation: { ...prev.extracted_text.Quotation, Items: items },
  //             },
  //         };
  //     });
  // };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) {
      Swal.fire({
        icon: "warning",
        title: "No Image Selected",
        text: "Please select an image before uploading.",
        confirmButtonColor: "#f0ad4e",
      });
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("model", "gpt-4.1");

    try {
      setLoading(true);

      const res = await fetch("http://192.168.1.19:5000/extract-text", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Server error:", errorText);

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: errorText,
          confirmButtonColor: "#d33",
        });

        return;
      }

      const data = await res.json();
      setResponseData(data);

      if (!data || Object.keys(data).length === 0) {
        Swal.fire({
          icon: "info",
          title: "No Data Found",
          text: "There is no readable data in the image.",
          confirmButtonColor: "#3085d6",
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Extraction Successful",
          text: "Image data extracted successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Network error:", error);

      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Upload failed. Please check your connection.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleFinalSubmit = async () => {
  //     if (!selectedStore) {
  //         Swal.fire({
  //             icon: "warning",
  //             title: "Store Required",
  //             text: "Please select a store before submitting.",
  //             confirmButtonColor: "#f0ad4e",
  //         });
  //         return;
  //     }
  //     setLoading(true);

  //     const payload = {
  //         ...responseData,
  //         StoreId: selectedStore.value,   // send store id
  //     };

  //     try {
  //         const res = await fetch("http://192.168.1.19:5000/save-quotation", {
  //             method: "POST",
  //             headers: {
  //                 "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify(payload),
  //         });

  //         const data = await res.json();

  //         if (res.ok) {
  //             Swal.fire({
  //                 icon: "success",
  //                 title: "Success",
  //                 text: "Quotation saved successfully!",
  //                 confirmButtonColor: "#3085d6",
  //             });

  //             console.log("Server Response:", data);
  //         } else {
  //             Swal.fire({
  //                 icon: "error",
  //                 title: "Failed",
  //                 text: "Failed to save quotation.",
  //                 confirmButtonColor: "#d33",
  //             });
  //         }
  //     } catch (error) {
  //         console.error("Submit Error:", error);

  //         Swal.fire({
  //             // icon: "warning",
  //             // title: "Network Error",
  //             // text: "Please check your connection and try again.",
  //             // confirmButtonColor: "#f0ad4e",
  //             icon: "success",
  //             title: "Success",
  //             text: "Quotation saved successfully!",
  //             confirmButtonColor: "#3085d6",
  //         });
  //         navigate("/advance-booking")

  //     } finally {
  //         setLoading(false);
  //     }
  // };
  // const handleFinalSubmit = async () => {
  //     if (!selectedStore) {
  //         Swal.fire({
  //             icon: "warning",
  //             title: "Store Required",
  //             text: "Please select a store before submitting.",
  //             confirmButtonColor: "#f0ad4e",
  //         });
  //         return;
  //     }

  //     if (!quotation || !quotation.Items?.length) {
  //         Swal.fire({
  //             icon: "warning",
  //             title: "No Items",
  //             text: "No quotation items to save.",
  //             confirmButtonColor: "#f0ad4e",
  //         });
  //         return;
  //     }

  //     setLoading(true);

  //     // Build the exact payload the backend expects
  //     const payload = {
  //         orgid: userDataSession?.OrgId || 41111,
  //         userid: userDataSession?.UserId || 586,
  //         storeId: selectedStore.value,

  //         name: quotation.MS || "",
  //         mobile: quotation.Phone?.replace(/[^0-9]/g, '') || "",
  //         address: quotation.Add || "",
  //         billNo: (quotation["Bill No"] || "").replace(/,/g, ""), // clean comma
  //         quotationDate: quotation.Date || null, // keep as-is (backend can parse)
  //         paymentType: quotation.Type || "CASH",
  //         itemsCount: quotation.Items?.length || 0,
  //         advance: quotation.AdvanceAmount || 0, // if you add this field
  //         total: quotation.Items?.reduce((sum, item) => sum + (Number(item.Amt) || 0), 0) || 0,
  //         transport: 0, // add input field if needed
  //         goodsPolicy: quotation.Note || quotation["Goods Policy"] || "",
  //         signatory: quotation["Authorised Signatory"] || "",
  //         notes: "", // or combine other notes
  //         totalQty: quotation.Total?.match(/\d+/)?.[0] || quotation.Items?.reduce((sum, i) => sum + Number(i.Qty || 0), 0) || 0,
  //         tokens: responseData.tokens.total_tokens || null,

  //         // Items as JSON string (backend will parse it)
  //         EstimateDetailsJson: JSON.stringify(
  //             quotation.Items.map((item, idx) => ({
  //                 SNo: item.SNo || idx + 1,
  //                 Size: item.Size || "",
  //                 Code: item.Code || "",
  //                 "Item Desc": item["Item Desc"] || "",
  //                 Location: item.Location || "",
  //                 Qty: Number(item.Qty) || 0,
  //                 Unit: item.Unit || "Sft",
  //                 Rate: Number(item.Rate) || 0,
  //                 Amt: Number(item.Amt) || 0,
  //                 // Optional: add ProductId if you resolve it in UI
  //                 ProductId: item.ProductId || 0
  //             }))
  //         )
  //     };

  //     try {
  //         const res = await fetch(`${API_BASE_URL}Billing/SaveEstimateDetails`, {
  //             method: "POST",
  //             headers: {
  //                 "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify(payload),
  //         });

  //         const data = await res.json();

  //         if (res.ok) {
  //             Swal.fire({
  //                 icon: "success",
  //                 title: "Success",
  //                 text: "Quotation saved successfully!",
  //                 timer: 2000,
  //                 showConfirmButton: false,
  //             });
  //             navigate("/advance-booking");
  //         } else {
  //             Swal.fire({
  //                 icon: "error",
  //                 title: "Failed",
  //                 text: data.error || "Failed to save quotation.",
  //             });
  //         }
  //     } catch (error) {
  //         console.error("Submit Error:", error);
  //         Swal.fire({
  //             icon: "error",
  //             title: "Network Error",
  //             text: "Could not connect to server.",
  //         });
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const handleFinalSubmit = async () => {
    if (!selectedStore || !file) {
      Swal.fire({ icon: "warning", title: "Store & Image Required" });
      return;
    }

    setLoading(true);

    const formData = new FormData();

    // Append all fields as text
    formData.append("orgid", userDataSession.OrgId);
    formData.append("userid", userDataSession.UserId);
    formData.append("storeId", selectedStore.value);
    formData.append("name", quotation.MS || "");
    formData.append("mobile", quotation.Phone?.replace(/[^0-9]/g, "") || "");
    formData.append("address", quotation.Add || "");
    formData.append("billNo", (quotation["Bill No"] || "").replace(/,/g, ""));
    formData.append("quotationDate", quotation.Date || "");
    formData.append("paymentType", quotation.Type || "CASH");
    formData.append("itemsCount", quotation.Items?.length || 0);
    formData.append("advance", 200); // or from input
    formData.append(
      "total",
      quotation.Items?.reduce((s, i) => s + Number(i.Amt || 0), 0) || 0,
    );
    formData.append("transport", 0);
    formData.append("goodsPolicy", quotation.Note || "");
    formData.append("signatory", quotation["Authorised Signatory"] || "");
    formData.append("notes", "");
    formData.append(
      "totalQty",
      quotation.Items?.reduce((s, i) => s + Number(i.Qty || 0), 0) || 0,
    );

    // Items as JSON string
    formData.append(
      "EstimateDetailsJson",
      JSON.stringify(
        quotation.Items.map((item, idx) => ({
          SNo: item.SNo || idx + 1,
          Size: item.Size || "",
          Code: item.Code || "",
          "Item Desc": item["Item Desc"] || "",
          Location: item.Location || "",
          Qty: Number(item.Qty) || 0,
          Unit: item.Unit || "Sft",
          Rate: Number(item.Rate) || 0,
          Amt: Number(item.Amt) || 0,
        })),
      ),
    );

    // Append the actual image file
    formData.append("image", file);

    try {
      const res = await fetch(
        `${API_BASE_URL}Billing/InsertQuotationWithImage`,
        {
          method: "POST",
          body: formData, // NO Content-Type header — browser sets multipart/form-data
        },
      );

      const data = await res.json();

      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Saved",
          text: `Quotation ID: ${data.QuotationId}`,
        });
        navigate("/estimates");
      } else {
        Swal.fire({ icon: "error", title: "Failed", text: data.error });
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Network Error" });
    } finally {
      setLoading(false);
    }
  };
  const [preview, setPreview] = useState("./assets/img/users/user-49.png");
  const [storesData, setStoresData] = useState([]);
  console.log(storesData, "sssssssssssssssssssssssssssssssssssss");
  const [userDataSession, setUserDataSession] = useState([]);
  console.log(userDataSession, "userdatasesssion");
  const [selectedStore, setSelectedStore] = useState(null);
  console.log(selectedStore, "selectedstore");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      handleFileChange(e); // keep your existing upload logic
    }
  };

  const fetchStores = async () => {
    if (!userDataSession?.OrgId || !userDataSession?.UserId) return;
    try {
      const url = `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Failed to fetch stores");
      }

      const data = await response.json();

      if (data) {
        setStoresData(data.ResultData);
      } else {
        console.error("Error fetching data:", data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (userDataSession?.OrgId && userDataSession?.UserId) {
      fetchStores();
    }
  }, [userDataSession]);

  const storeOptions = [
    ...(Array.isArray(storesData)
      ? storesData.map((store) => ({
          value: store.StoreId,
          label: store.Name,
        }))
      : []),
  ];

  console.log(storeOptions, "storeoptions");

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
  };

  const keyLabels = {
    "Item Desc": "Description",
    Qty: "Quantity",
    Rate: "Unit Price(Rate)",
    Amt: "Amount",
    Size: "Size",
    Code: "Item Code",
    Unit: "Unit",
    Location: "Location",
  };
  return (
    <>
      {loading && <SpinLoader />}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Smart Invoice Image Processing</h4>
                <h6>
                  Upload an invoice image to extract and manage its details
                </h6>
              </div>
            </div>
          </div>

          <hr />

          <div className="d-flex justify-content-center">
            <div className="card  shadow-sm col-8">
              <div className="card-body row align-items-center">
                <div className="">
                  <div className="profile-pic-upload image-field mb-0">
                    <style>
                      {`.profile-pic-upload .profile-pic {
                                               width: 350px;
                                               height: 200px;
                                               border: 1px dashed #5B6670;
                                               display: flex;
                                               align-items: center;
                                               -webkit-box-align: center;
                                               -ms-flex-align: center;
                                               justify-content: center;
                                               -webkit-justify-content: center;
                                               -ms-flex-pack: center;
                                               border-radius: 10px;
                                               margin-right: 24px;
                                               position: relative;
                                               flex-shrink: 0;
                                               
                                           }`}
                    </style>
                    <div className="profile-pic p-2 position-relative">
                      <img
                        src={preview}
                        className="object-fit-cover rounded-1"
                        alt="preview"
                        style={{ width: "350px", height: "200px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-danger position-absolute top-0 end-0"
                        onClick={() =>
                          setPreview("./assets/img/users/user-49.png")
                        }
                      >
                        ×
                      </button>
                    </div>
                    <div className="mt-2">
                      <div className="image-upload d-inline-flex align-items-center">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                          id="imageUpload"
                        />
                        <label
                          htmlFor="imageUpload"
                          className="btn btn-primary btn-sm"
                        >
                          Select Image
                        </label>
                      </div>

                      <button
                        className="btn btn-success btn-sm m-3"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? "Uploading..." : "Upload"}
                      </button>

                      <p className="mt-2 mb-0 text-muted small">
                        Upload an image below 2 MB. Accepted: JPG, PNG
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr className="my-2" />

          {quotation ? (
            <div className="card p-4 shadow-sm">
              <div className="mb-2">
                <label className="form-label">Store :</label>
                <Select
                  className="select"
                  options={storeOptions}
                  placeholder="Select Store"
                  onChange={handleStoreChange}
                  value={selectedStore}
                  style={{ width: "180px" }}
                />
              </div>

              {/* <div className="row">


                                <div className="col-md-6">
                                    <div className="card p-3 shadow-sm h-100">
                                        <h5 className="mb-3">Company Info</h5>

                                        <div className="mb-3">
                                            <label>Company Name</label>
                                            <input
                                                className="form-control"
                                                value={quotation.MS || ""}
                                                onChange={(e) =>
                                                    updateQuotationField("MS", e.target.value)
                                                }
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label>Address</label>
                                            <input
                                                className="form-control"
                                                value={quotation.Add || ""}
                                                onChange={(e) =>
                                                    updateQuotationField("Add", e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="card p-3 shadow-sm h-100">
                                        <h5 className="mb-3">Invoice Details</h5>

                                        <div className="row">
                                            <div className="col-6 mb-3">
                                                <label>Phone</label>
                                                <input
                                                    className="form-control"
                                                    value={quotation.Phone || ""}
                                                    onChange={(e) =>
                                                        updateQuotationField("Phone", e.target.value)
                                                    }
                                                />
                                            </div>

                                            <div className="col-6 mb-3">
                                                <label>Bill No</label>
                                                <input
                                                    className="form-control"
                                                    value={quotation["Bill No"] || ""}
                                                    onChange={(e) =>
                                                        updateQuotationField("Bill No", e.target.value)
                                                    }
                                                />
                                            </div>

                                            <div className="col-6 mb-3">
                                                <label>Date</label>
                                                <input
                                                    className="form-control"
                                                    value={quotation.Date || ""}
                                                    onChange={(e) =>
                                                        updateQuotationField("Date", e.target.value)
                                                    }
                                                />
                                            </div>

                                            <div className="col-6 mb-3">
                                                <label>Type</label>
                                                <input
                                                    className="form-control"
                                                    value={quotation.Type || ""}
                                                    onChange={(e) =>
                                                        updateQuotationField("Type", e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div> */}
              <div className="row">
                {/* Company Info */}
                <div className="col-md-4">
                  <h5 className="mb-3">Company Info</h5>

                  {/* Add row here */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Company Name</label>
                      <input
                        className="form-control"
                        value={quotation.MS || ""}
                        onChange={(e) =>
                          updateQuotationField("MS", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Address</label>
                      <input
                        className="form-control"
                        value={quotation.Add || ""}
                        onChange={(e) =>
                          updateQuotationField("Add", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Invoice Details */}
                <div className="col-md-8 border-start border-3 ps-3">
                  <h5 className="mb-3 ">Invoice Details</h5>

                  <div className="row">
                    <div className="col-3 mb-3">
                      <label>Phone</label>
                      <input
                        className="form-control"
                        value={quotation.Phone || ""}
                        onChange={(e) =>
                          updateQuotationField("Phone", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-3 mb-3">
                      <label>Bill No</label>
                      <input
                        className="form-control"
                        value={quotation["Bill No"] || ""}
                        onChange={(e) =>
                          updateQuotationField("Bill No", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-3 mb-3">
                      <label>Date</label>
                      <input
                        className="form-control"
                        value={quotation.Date || ""}
                        onChange={(e) =>
                          updateQuotationField("Date", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-3 mb-3">
                      <label>Type</label>
                      <input
                        className="form-control"
                        value={quotation.Type || ""}
                        onChange={(e) =>
                          updateQuotationField("Type", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <h5 className="my-3">Items</h5>
              {/* <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                {quotation.Items?.map((item, index) => (
                                    <div className="card mb-3 shadow-sm" key={index}>
                                        <div className="card-body">
                                            <h6>Item #{index + 1}</h6>
                                            <div className="row">
                                                {Object.keys(item).map((key) => (
                                                    <div className="col-2 mb-2" key={key}>
                                                        <label>{key}</label>
                                                        <input
                                                            className="form-control"
                                                            value={item[key] || ""}
                                                            onChange={(e) =>
                                                                updateQuotationItem(
                                                                    index,
                                                                    key,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> */}

              {/* <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <table className="table ">

                                    <thead className=" text-white">
                                        <tr>
                                            {quotation.Items && quotation.Items.length > 0 &&
                                                Object.keys(quotation.Items[0]).map((key) => (
                                                    <th key={key}>{key}</th>
                                                ))
                                            }
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {quotation.Items?.map((item, index) => (
                                            <tr key={index}>
                                                {Object.keys(item).map((key) => (
                                                    <td key={key}>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            value={item[key] || ""}
                                                            onChange={(e) =>
                                                                updateQuotationItem(
                                                                    index,
                                                                    key,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div> */}

              {/* TABLEFORMATE */}

              {/* <div style={{ maxHeight: "400px", overflow: "auto" }}>
                                <table
                                    className="table  align-middle"
                                    style={{ width: "100%", tableLayout: "auto" }}
                                >
                                    <thead className=" text-nowrap">
                                        <tr>
                                            {quotation.Items &&
                                                Object.keys(quotation.Items[0]).map((key) => (
                                                    <th
                                                        key={key}
                                                        style={{
                                                            width:
                                                                key === "SNo"
                                                                    ? "60px"
                                                                    : key === "Qty"
                                                                        ? "80px"
                                                                        : key === "Rate"
                                                                            ? "100px"
                                                                            : key === "Amt"
                                                                                ? "120px"
                                                                                : key === "Size"
                                                                                    ? "90px"
                                                                                    : key === "Code"
                                                                                        ? "90px"
                                                                                        :key === "Unit"
                                                                                        ? "100px"
                                                                                        : "auto", // Item Desc & Location auto expand
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {key}
                                                    </th>
                                                ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {quotation.Items?.map((item, index) => (
                                            <tr key={index}>
                                                {Object.keys(item).map((key) => (
                                                    <td key={key}>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            value={item[key] || ""}
                                                            onChange={(e) =>
                                                                updateQuotationItem(index, key, e.target.value)
                                                            }
                                                            style={{
                                                                minWidth:
                                                                    key === "Item Desc"
                                                                        ? "200px"
                                                                        : "auto",
                                                            }}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div> */}

              <div style={{ maxHeight: "400px", overflow: "auto" }}>
                <table
                  className="table align-middle table-hover"
                  style={{ width: "100%", tableLayout: "auto" }}
                >
                  <thead
                    className="table-light bg-light"
                    style={{ position: "sticky", top: 0, zIndex: 10 }}
                  >
                    <tr>
                      {quotation.Items &&
                        Object.keys(quotation.Items[0]).map((key) => (
                          <th
                            key={key}
                            style={{
                              width:
                                key === "SNo"
                                  ? "60px"
                                  : key === "Qty"
                                    ? "80px"
                                    : key === "Rate"
                                      ? "100px"
                                      : key === "Amt"
                                        ? "120px"
                                        : key === "Size"
                                          ? "90px"
                                          : key === "Code"
                                            ? "90px"
                                            : key === "Unit"
                                              ? "100px"
                                              : "auto",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {key}
                          </th>
                        ))}

                      {/* Edit Column Header */}
                      <th
                        style={{
                          width: "70px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Edit
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {quotation.Items?.map((item, index) => (
                      <tr key={index}>
                        {Object.keys(item).map((key) => (
                          <td
                            key={key}
                            style={{
                              minWidth: key === "Item Desc" ? "200px" : "auto",
                              whiteSpace: "nowrap",
                              verticalAlign: "middle",
                            }}
                          >
                            {item[key] || "-"}
                          </td>
                        ))}

                        {/* Edit Icon Column */}
                        {/* <td className="text-center">
                                                    <button
                                                        className="btn btn-sm btn-info"
                                                        onClick={() => handleEditClick(item, index)}
                                                    >
                                                         <Edit className="feather-edit" />
                                                    </button>
                                                </td> */}
                        <td className="text-center">
                          <a
                            href="#!"
                            onClick={() => handleEditClick(item, index)}
                            className="text-decoration-none text-innfo d-flex justify-content-center align-items-center"
                          >
                            <Edit size={16} />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="row mt-3">
                <div className="col-2 mb-2">
                  <h5>Totals</h5>
                  <input
                    className="form-control mb-2"
                    value={quotation.Total || ""}
                    onChange={(e) =>
                      updateQuotationField("Total", e.target.value)
                    }
                  />
                </div>

                <div className="col-2 mb-2">
                  <h5>Signature</h5>
                  <input
                    className="form-control"
                    value={quotation["Authorised Signatory"] || ""}
                    onChange={(e) =>
                      updateQuotationField(
                        "Authorised Signatory",
                        e.target.value,
                      )
                    }
                  />
                </div>

                <div className="col-4 mb-2">
                  <h4>Note</h4>
                  <input
                    className="form-control"
                    value={quotation.Note || ""}
                    onChange={(e) =>
                      updateQuotationField("Note", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <button className="btn btn-success" onClick={handleFinalSubmit}>
                  Submit
                </button>
              </div>
            </div>
          ) : (
            <p className="text-muted">No data extracted yet.</p>
          )}
        </div>
      </div>

      {showCanvas && (
        <div
          className="offcanvas-backdrop"
          onClick={() => setShowCanvas(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(3px)",
            zIndex: 1040,
          }}
        />
      )}

      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100%",
          width: "500px",
          backgroundColor: "#fff",
          zIndex: 1050,
          transform: showCanvas ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease-in-out",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="offcanvas-header border-bottom p-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Edit Item</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowCanvas(false)}
          ></button>
        </div>

        <div className="offcanvas-body p-3">
          {editItem && (
            <div className="row">
              {Object.keys(editItem)
                .filter((key) => key !== "SNo")
                .map((key) => (
                  <div className="col-md-6 mb-3" key={key}>
                    <label className="form-label">
                      {" "}
                      {keyLabels[key] || key}
                    </label>
                    <input
                      className="form-control"
                      value={editItem[key] || ""}
                      onChange={(e) =>
                        setEditItem({
                          ...editItem,
                          [key]: e.target.value,
                        })
                      }
                    />
                  </div>
                ))}
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end gap-2 ">
          <button
            className="btn btn-secondary"
            onClick={() => setShowCanvas(false)} // Cancel closes the offcanvas
          >
            Cancel
          </button>
          <button className="btn btn-success" onClick={handleSubmitOfcanvas}>
            Submit
          </button>
        </div>
      </div>
    </>
  );
}

export default ImageUpload;
